import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import CacheService from '../services/cacheService';

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={props => (
	    CacheService.getToken()
	        ? <Component {...props} {...rest} />
	        : <Redirect to={{ pathname: `/${props.match.params.bname}/login`, state: { from: props.location } }} />
	)} />
);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/privateRoute.js